import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('auth-rep-sign')
@Component({
    selector: 'app-auth-rep-sign',
    templateUrl: './auth-rep-sign.component.html',
    styleUrls: ['./auth-rep-sign.component.scss'],
    standalone: false
})
export class AuthRepSignComponent extends FormEntryComponentClass implements OnInit {

  constructor() {
    super();
   }

  ngOnInit(): void {
  }

}
